import { render, staticRenderFns } from "./StandardConstruction.vue?vue&type=template&id=4df64e30"
import script from "./StandardConstruction.vue?vue&type=script&lang=js"
export * from "./StandardConstruction.vue?vue&type=script&lang=js"
import style0 from "./StandardConstruction.vue?vue&type=style&index=0&id=4df64e30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports